export const PERFIS = [
  { value: 'operador', label: 'Operador' },
  { value: 'admin', label: 'Admin' },
  { value: 'super_admin', label: 'Super Admin' },
];

export const STATUS_PEDIDO = [
  { value: 'rascunho', label: 'Rascunho' },
  { value: 'confirmado', label: 'Confirmado' },
  { value: 'cancelado', label: 'Cancelado' },
];

export const TIPOS_AJUSTE = [
  { value: 'perda', label: 'Perda' },
  { value: 'quebra', label: 'Quebra' },
  { value: 'avaria', label: 'Avaria' },
  { value: 'outro', label: 'Outro' },
];
